import { forwardRef, createElement, useContext } from 'react';
import { AnalyticsContext } from './AnalyticsContext';
import { AnalyticsProviderContext } from './AnalyticsProviderContext';
import { ANALYTICS_EVENT_NAMES } from './analytics_event_names';

/**
 * Like `Analytics`, the wrapper forwards every prop through and so has the same
 * props as `wrappedComponent` — it only decorates `onClick`. Stating that is
 * necessary because a `forwardRef` written in a `.js` file infers no props.
 *
 * @template {React.ComponentType<any>} C
 * @param {C} wrappedComponent
 * @returns {React.ForwardRefExoticComponent<React.ComponentProps<C> & React.RefAttributes<unknown>>}
 */
const ClickTracker = (wrappedComponent) => {
  const ClickTrackerWrapper = forwardRef((props, ref) => {
    const analytics = useContext(AnalyticsProviderContext);
    const analyticsData = useContext(AnalyticsContext);

    const handleClick = (...args) => {
      const { onClick } = props;
      analytics.track(ANALYTICS_EVENT_NAMES.CLICK, analyticsData);
      return onClick?.(...args);
    };

    return createElement(wrappedComponent, {
      ...props,
      ref,
      onClick: handleClick,
    });
  });

  return ClickTrackerWrapper;
};

export default ClickTracker;
